
        import * as module0 from './controllers/bulma_phlex/navigation_bar_controller.js';import * as module1 from './controllers/carousel_controller.js';import * as module2 from './controllers/comments_controller.js'
        const modules = {
            "./controllers/bulma_phlex/navigation_bar_controller.js": module0,
            "./controllers/carousel_controller.js": module1,
            "./controllers/comments_controller.js": module2,
        };
        export default modules;
      